import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    ChallengeTemplateRepository,
    RequestGetChallengeTemplates,
    PostBeforeChallengeTemplatePayload,
    PostAfterChallengeTemplatePayload,
} from "@/entities/challenge-template/domain/repository";
import type {
    GetChallengeTemplatesResponseDto,
    ChallengeTemplateDto,
} from "@/entities/challenge-template/domain/dtos";

@singleton()
export default class ChallengeTemplateRepositoryImpl implements ChallengeTemplateRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    /** @description 챌린지 템플릿 목록 조회 */
    getChallengeTemplates = async (request: RequestGetChallengeTemplates) => {
        let url = `/v1/challenge-templates?`;

        url += `academyId=${request.academyId}&`;

        // 챌린지 타입 반복 추가
        request.type.forEach((type) => {
            url += `type=${type}&`;
        });

        if (request.from) {
            url += `from=${request.from}&`;
        }

        if (request.to) {
            url += `to=${request.to}&`;
        }

        if (request.keyword) {
            url += `keyword=${request.keyword}&`;
        }

        url += `size=${request.size}&`;
        url += `order=${request.order}&`;

        if (request.nextToken) {
            url += `nextToken=${request.nextToken}`;
        }

        const response = await this.server.get<GetChallengeTemplatesResponseDto>(url);

        return response;
    };

    /** @description 챌린지 템플릿 삭제 */
    deleteChallengeTemplate = async (challengeTemplateId: string) => {
        await this.server.delete(`/v1/challenge-templates/${challengeTemplateId}`);
    };

    /**
     * @description 비포챌린지 템플릿 생성
     * @param {PostBeforeChallengeTemplatePayload} payload - 비포챌린지 템플릿 생성 요청 데이터
     */
    postBeforeChallengeTemplate = async (payload: PostBeforeChallengeTemplatePayload) => {
        const response = await this.server.post<ChallengeTemplateDto>(
            "/v1/challenge-templates",
            payload,
        );

        return response;
    };

    /**
     * @description 애프터 챌린지 템플릿 생성
     * @param {PostAfterChallengeTemplatePayload} payload - 애프터 챌린지 템플릿 생성 요청 데이터
     */
    postAfterChallengeTemplate = async (payload: PostAfterChallengeTemplatePayload) => {
        const response = await this.server.post<ChallengeTemplateDto>(
            "/v1/challenge-templates",
            payload,
        );

        return response;
    };
}
